
import { 
  Music, 
  Video, 
  Mic, 
  Calendar, 
  Users, 
  Camera,
  Headphones,
  Star
} from 'lucide-react';
import type { Product } from './types';

export const entertainmentProducts: Product[] = [
  {
    id: 'event-production-platform',
    title: 'Event Production Platform',
    subtitle: 'Complete event production management',
    description: 'Comprehensive event production with planning, crew management, equipment tracking, and live event coordination for UK entertainment venues.',
    icon: Calendar,
    image: 'https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#event-production', '#live-events', '#concerts', '#festivals', '#entertainment-venues'],
    features: [
      'Event Planning & Timeline Management',
      'Crew & Staff Scheduling',
      'Equipment & Asset Management',
      'Vendor & Supplier Coordination',
      'Budget Tracking & Cost Control',
      'Permit & Licensing Management (UK venues)',
      'Health & Safety Risk Management',
      'Real-time Production Coordination',
      'VAT Management & Financial Reporting',
      'PRS/PPL Licensing Integration'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-purple-500 to-pink-600'
  },
  {
    id: 'music-production-suite',
    title: 'Music Production Suite',
    subtitle: 'Professional music creation platform',
    description: 'Complete music production management with project tracking, collaboration tools, rights management, and distribution.',
    icon: Music,
    image: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#music-production', '#recording-studios', '#music-labels', '#artists', '#sound-engineers'],
    features: [
      'Project & Session Management',
      'Multi-track Recording Interface',
      'Collaboration & File Sharing',
      'Rights & Royalty Management',
      'Distribution & Publishing',
      'Client & Artist Management',
      'Equipment & Studio Booking',
      'Financial Tracking & Invoicing'
    ],
    pricing: { setup: 32000, monthly: 1472 },
    color: 'from-blue-500 to-indigo-600'
  },
  {
    id: 'video-production-platform',
    title: 'Video Production Platform',
    subtitle: 'Professional video workflow management',
    description: 'Comprehensive video production with project management, asset organisation, post-production workflows, and delivery for UK market.',
    icon: Video,
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#video-production', '#film-studios', '#content-creators', '#advertising-agencies', '#media-companies'],
    features: [
      'Pre-production Planning & Scheduling',
      'Digital Asset Management (DAM)',
      'Post-production Workflow Management',
      'Collaboration & Review Tools',
      'Version Control & Approval Process',
      'Delivery & Distribution Management',
      'Client Communication & Feedback',
      'Budget & Resource Tracking'
    ],
    pricing: { setup: 35000, monthly: 1610 },
    color: 'from-red-500 to-pink-600'
  },
  {
    id: 'talent-management-system',
    title: 'Talent Management System',
    subtitle: 'Artist and performer management',
    description: 'Complete talent management with booking coordination, contract management, performance tracking, and career development.',
    icon: Star,
    image: 'https://images.unsplash.com/photo-1516280440614-37939bbacd81?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#talent-management', '#entertainment-agencies', '#artists', '#performers', '#booking-agencies'],
    features: [
      'Artist Profile & Portfolio Management',
      'Booking & Performance Scheduling',
      'Contract & Agreement Management',
      'Revenue & Royalty Tracking',
      'Career Development Planning',
      'Audition & Casting Management',
      'Marketing & Promotion Tools',
      'Financial Management & Reporting'
    ],
    pricing: { setup: 30000, monthly: 1380 },
    color: 'from-green-500 to-emerald-600'
  },
  {
    id: 'streaming-media-platform',
    title: 'Streaming Media Platform',
    subtitle: 'Content distribution and analytics',
    description: 'Advanced streaming platform with content management, audience analytics, monetization tools, and multi-platform distribution.',
    icon: Headphones,
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#streaming-platforms', '#content-creators', '#media-distribution', '#podcasting', '#online-entertainment'],
    features: [
      'Content Management & Organisation',
      'Multi-platform Distribution',
      'Audience Analytics & Insights',
      'Monetization & Subscription Management',
      'Live Streaming Capabilities',
      'Content Recommendation Engine',
      'Community & Engagement Tools',
      'Revenue Optimization & Reporting'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-cyan-500 to-blue-600'
  },
  {
    id: 'venue-management-system',
    title: 'Venue Management System',
    subtitle: 'Entertainment venue operations',
    description: 'Complete venue management with booking coordination, event planning, facilities management, and customer experience optimization.',
    icon: Users,
    image: 'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    category: 'Entertainment & Media',
    status: 'Available',
    businessTypes: ['#venue-management', '#entertainment-venues', '#theaters', '#concert-halls', '#event-spaces'],
    features: [
      'Venue Booking & Scheduling',
      'Event Planning & Coordination',
      'Ticketing & Box Office Management',
      'Facilities & Equipment Management',
      'Customer Experience Management',
      'Food & Beverage Operations',
      'Security & Safety Management',
      'Financial Reporting & Analytics'
    ],
    pricing: { setup: 38000, monthly: 1748 },
    color: 'from-orange-500 to-red-600'
  }
];
